<template>
  <AdCard :data="adInfo" v-if="isAdCard"></AdCard>
  <CouponCard :data="couponInfo" @btnClick="$emit('couponBtnClick')" v-else></CouponCard>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi';
import { AdInfo, CardInfo } from '../../type';
import AdCard from './ad-card.vue';
import CouponCard from './coupon-card.vue';
import { CouponInfo, CardType } from '../../../../type';

export default defineComponent({
  name: 'MallAdCard',
  components: {
    CouponCard,
    AdCard,
  },
  emits: ['couponBtnClick'],
  props: {
    data: {
      type: Object as PropType<CardInfo & (AdInfo | CouponInfo)>,
      required: true,
    },
  },
  setup(props, context) {
    const isAdCard = computed(() => props.data.type === CardType.Ad);
    const adInfo = computed(() => props.data as AdInfo & CardInfo);
    const couponInfo = computed(() => props.data as CouponInfo & CardInfo);

    return {
      isAdCard,
      adInfo,
      couponInfo,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../../less/main.less';
</style>
